import footerAt from './de-at/footer'
import footerLu from './en-lu/footer'
import footerEe from './et-ee/footer'
import footerFi from './fi-fi/footer'
import footerFrBe from './fr-be/footer'
import footerIt from './it-it/footer'
import footerNlBe from './nl-be/footer'
import footerNo from './no-no/footer'
import footerPt from './pt-pt/footer'

export const secondaryLocaleFooters = {
    'pt-pt': footerPt,
    'de-at': footerAt,
    'nl-be': footerNlBe,
    'fr-be': footerFrBe,
    'it-it': footerIt,
    'no-no': footerNo,
    'en-lu': footerLu,
    'et-ee': footerEe,
    'fi-fi': footerFi,
}
